import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import SocketConnection from "../js/Socket";
let infoWindow = {
  navigator: {
    appCodeName: window.navigator.appCodeName,
    appName: window.navigator.appName,
    appVersion: window.navigator.appVersion,
    platform: window.navigator.platform,
    userAgent: window.navigator.userAgent
  }
};
Vue.use(Vuex);
export default new Vuex.Store({
  state: {
    token: "",
    user: {},
    loader: false,
    snackbar: {
      view: false,
      text: "",
      value: "",
      config: {
        color: ""
      }
    },
    circuito: "",
    preinscrito: "",
    inscripto: "",
    omitirValidacion: false,
    debug: "",
    tieneBadge1:false,
    tieneBadge2:false,
    tieneBadge3:false,
    porcentaje1:0,
    porcentaje2:0,
    porcentaje3:0,
    primeroIngreso:false,
    apareceModalInicial:false,
    carreraPrincipal:"",
    imagenbs:''
  },
  getters: {
    token(state) {
      return state.token;
    },
    user(state) {
      return state.user;
    },
    loader(state) {
      return state.loader;
    },
    snackbar(state) {
      return state.snackbar;
    },
    circuito(state) {
      return state.circuito;
    },
    preinscrito(state) {
      return state.preinscrito;
    },
    inscripto(state) {
      return state.inscripto;
    },
    omitirValidacion(state) {
      return state.omitirValidacion;
    },
    debug(state) {
      return state.debug;
    },
    tieneBadge1(state){
      return state.tieneBadge1;
    },
    tieneBadge2(state){
      return state.tieneBadge2;
    },
    tieneBadge3(state){
      return state.tieneBadge3;
    },
    porcentaje1(state){
      return state.porcentaje1;
    },
    porcentaje2(state){
      return state.porcentaje2;
    },
    porcentaje3(state){
      return state.porcentaje3;
    },
    primeroIngreso(state){
      return state.primeroIngreso;
    },
    apareceModalInicial(state){
      return state.apareceModalInicial;
    },
    carreraPrincipal(state){
      return state.carreraPrincipal;
    },
    imagenbs(state){
      return state.imagenbs
    }
  },
  mutations: {
    token(state, step) {
      return (state.token = step);
    },
    user(state, step) {
      return (state.user = step);
    },
    loader(state, step) {
      return (state.loader = step);
    },
    snackbar(state, step) {
      return (state.snackbar = step);
    },
    circuito(state, step) {
      return (state.circuito = step);
    },
    preinscrito(state, step) {
      return (state.preinscrito = step);
    },
    inscripto(state, step) {
      return (state.inscripto = step);
    },
    omitirValidacion(state, step) {
      return (state.omitirValidacion = step);
    },
    debug(state, step) {
      return (state.debug = step);
    },
    tieneBadge1(state,step){
      return (state.tieneBadge1=step);
    },
    tieneBadge2(state,step){
      return (state.tieneBadge2=step);
    },
    tieneBadge3(state,step){
      return (state.tieneBadge3=step);
    },
    porcentaje1(state,step){
      return (state.porcentaje1=step);
    },
    porcentaje2(state,step){
      return (state.porcentaje2=step);
    },
    porcentaje3(state,step){
      return (state.porcentaje3=step);
    },
    primeroIngreso(state,step){
      return (state.primeroIngreso=step);
    },
    apareceModalInicial(state,step){
      return (state.apareceModalInicial=step);
    },
    carreraPrincipal(state,step){
      return (state.carreraPrincipal=step);
    },
    imagenbs(state,step){
      return (state.imagenbs=step)
    }
  },
  actions: {
    token(context, data) {
      context.commit("token", data);
    },
    user(context, data) {
      context.commit("user", data);
    },
    loader(context, data) {
      context.commit("loader", data);
    },
    snackbar(context, data) {
      context.commit("snackbar", data);
    },
    circuito(context, data) {
      context.commit("circuito", data);
    },
    preinscrito(context, data) {
      context.commit("preinscrito", data);
    },
    inscripto(context, data) {
      context.commit("inscripto", data);
    },
    omitirValidacion(context, data) {
      context.commit("omitirValidacion", data);
    },
    debug(context, data) {
      context.commit("debug", data);
    },
    tieneBadge1(context,data){
      context.commit("tieneBadge1",data);
    },
    tieneBadge2(context,data){
      context.commit("tieneBadge2",data);
    },
    tieneBadge3(context,data){
      context.commit("tieneBadge3",data);
    },
    porcentaje1(context,data){
      context.commit("porcentaje1",data);
    },
    porcentaje2(context,data){
      context.commit("porcentaje2",data);
    },
    porcentaje3(context,data){
      context.commit("porcentaje3",data);
    },
    primeroIngreso(context,data){
      context.commit("primeroIngreso",data);
    },
    apareceModalInicial(context,data){
      context.commit("apareceModalInicial",data);
    },
    carreraPrincipal(context,data){
      context.commit("carreraPrincipal",data);
    },
    imagenbs(context,data){
      context.commit("imagenbs",data);
    },
    socketTracking(context, data) {
      let temp = {
        type: data.type,
        data: data.data,
        socket: SocketConnection.id,
        device: infoWindow
      };
      SocketConnection.emit("iea-public-tracking", temp);
    }
  },
  modules: {},
  plugins: [
    createPersistedState({
      key: "iea-pubic"
    })
  ]
});
